export default {
  localizationCountrySet: 'localization-country-set',
  logout: 'logout',
  loginState: 'login-state',
  shownUpgradesChanged: 'shown-upgrades-changed',
};
